export default __webpack_public_path__ + "static/radler-logo_EN-6158026840b0c2c360cc00fba2b78d84.svg";